import {CMSConfiguration, CMSStaticSection, JCMSStaticSections, JPage} from "@jnext/commons"
import React, {FC, useEffect, useMemo} from "react"
import {Navigate} from "react-router-dom"
import {useCMSStore} from "store/cmsStore"
import MetaTags from "../../components/MetaTags/MetaTags"
import {finalizationCallback, mzUseNavigate} from "../../utils"

export const Faq: FC = () => {
    const navigate = mzUseNavigate()
    const {pages, setCurrentPage} = useCMSStore()
    const config: CMSConfiguration|undefined = useMemo(() => pages?.faq, [pages?.faq])

    useEffect(() => {
        setCurrentPage(pages?.faq ?? undefined)
        if (config?.section?.sections) {
            finalizationCallback(config?.section?.sections, navigate)
        }
    }, [config?.page])

    if (!config) {
        return <Navigate to="/404" />
    }

    return(<>
            {config.page && (
                <JPage {...config.page} options={config.page.options || {headerAlign: "center"}}>
                    <MetaTags pageConfiguration={config.page} />
                    <JCMSStaticSections.Content {...config.section as CMSStaticSection.Content} />
                </JPage>
            )}
        </>
    )
}